// ----------------------------------------------------------------------
// <copyright file='Izenda.NameEditor.jsx' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var ReactDOM = require('react-dom');
  var connect = require('share/enhancers/Izenda.Connect');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var constants = require('logic/data/Izenda.ReportsConstants');
  var TextHighLight = require('share/components/controls/Izenda.TextHighLight');
  var Input = Validator()(require('share/components/controls/Izenda.Input'));
  var ACCESS_RIGHT = require('logic/data/Izenda.AuthorizationConstants').ACCESS_RIGHT;
  var SearchCriteria = constants.SEARCH_CRITERIA;

  const { isNil } = require('lodash/fp');

  var NameEditor = React.createClass({
    propTypes: {
      store: React.PropTypes.object,
      dataDetail: React.PropTypes.object,
      validationMessage: React.PropTypes.object,
      title: React.PropTypes.string,
      changeName: React.PropTypes.func
    },

    componentWillMount: function() {
      this.originalName = this.props.dataDetail.name;
    },

    getInitialState: function() {
      return {
        editMode: false
      };
    },

    /**
     * Handle enter
     * @param {Object} event
     */
    handleEnter: function(e) {
      if (e.key === 'Enter') {
        this.handleSave();
      }
    },

    /**
     * Handle save report name
     */
    handleSave: function(e) {
      // Stop event blur if current event is mouse down
      if (e && e.type === 'mousedown') {
        e.preventDefault();
        e.stopPropagation();
      }

      var props = this.props;
      var dataDetail = this.props.dataDetail;
      var valManager = this.props.validation;
      var loader = this.props.loader;

      if (dataDetail.name === this.originalName) {
        props.changeName && props.changeName();
        this.setState({ editMode: false });
        return;
      }

      loader.startLoading();
      valManager
        .validate('Name')
        .then(
          function(success) {
            if (success) {
              return props.store.validateName(dataDetail, dataDetail.name).then(
                function(response) {
                  if (isNil(response)) {
                    this.originalName = props.dataDetail.name;
                    props.changeName && props.changeName();
                    this.setState({ editMode: false });
                  } else {
                    ReactDOM.findDOMNode(this.refs.inputName.refs.editor).focus();
                  }
                  valManager.updateErrors(response);
                }.bind(this)
              );
            }
          }.bind(this)
        )
        .finally(loader.endLoading.bind(loader));
    },

    /**
     * Handle cancel button
     */
    handleCancel: function() {
      this.setState({ editMode: false });
      this.props.dataDetail.name = this.originalName;
    },

    /**
     * Rename
     * @param {Object} event
     */
    handleRename: function(e) {
      this.originalName = this.props.dataDetail.name;
      this.setState({ editMode: true });
      e.preventDefault();
      e.stopPropagation();
    },

    /**
     * Change name
     * @param {Object} input
     */
    onChangeName: function(input) {
      this.props.dataDetail.name = input.target.value;
      this.setState({ editMode: this.state.editMode });
    },

    /**
     * Render report name component with edit mode
     * @return {Object} component
     */
    renderNameWithEditMode: function(localization) {
      var dataDetail = this.props.dataDetail;

      return (
        <div className="title-edit">
          <div className="input-group">
            <Input
              ref="inputName"
              value={dataDetail.name}
              onChange={this.onChangeName}
              onKeyPress={this.handleEnter}
              onBlur={this.handleSave}
              field="Name"
              validations={this.props.validationMessage}
              className="form-control"
              autoFocus
            />
            <span className="input-group-btn">
              <button
                className="btn btn-default"
                onMouseDown={this.handleSave}
                title={localization.getText('COMMON_TOOLTIP_UPDATE_CHANGE')}
              >
                <span className="icon-ok success-color" />
              </button>
              <button
                className="btn btn-default"
                onMouseDown={this.handleCancel}
                title={localization.getText('COMMON_TOOLTIP_CANCEL_CHANGE')}
              >
                <span className="icon-cancel" />
              </button>
            </span>
          </div>
        </div>
      );
    },

    /**
     * Render name with view mode
     * @return {Object} component
     */
    renderNameWithViewMode: function() {
      var dataDetail = this.props.dataDetail;
      var model = this.props.store.items || {};
      var accessPriority = dataDetail.accessPriority;
      var isPencilButtonVisible = this.props.newDashboard ||
        accessPriority === ACCESS_RIGHT.FullAccess ||
        accessPriority === ACCESS_RIGHT.SaveAs;

        return (
        <div className="u_flexHorizontal">
          <div className="u_textTruncate">
            <TextHighLight
              highlight={model.searchText}
              text={dataDetail.name}
              className="text-bold"
              notHighlight={
                dataDetail.isNotHighLight && dataDetail.isNotHighLight(model.searchType, SearchCriteria[1].value)
              }
            />
          </div>
          {isPencilButtonVisible && (<div className="u_fullInlineBlock">
            <a onClick={this.handleRename}>
              <span className="icon-pencil-new" title={this.props.title} />
            </a>
          </div>)}
        </div>
      );
    },

    /**
     * Render component
     * @return {Object} component
     */
    render: function() {
      var dataDetail = this.props.dataDetail;
      var localization = this.props.localization;

      return (
        <div className="izenda-NameEditor u_paddingTop">
          {this.state.editMode ? this.renderNameWithEditMode(localization) : this.renderNameWithViewMode()}
        </div>
      );
    }
  });

  module.exports = connect()(NameEditor);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/NameEditor/Izenda.NameEditor.jsx